import React from 'react';
import classnames from 'classnames';
import SvgIcon from '../../atoms/SvgIcon/SvgIcon';

var _ref2 = React.createElement(SvgIcon, {
  iconName: "ico_delete",
  color: "black",
  className: "menu__mobile-close-button-icon"
});

var MobileMenuCloseButton = function MobileMenuCloseButton(_ref) {
  var onClick = _ref.onClick;
  return React.createElement("button", {
    className: "menu__mobile-close-button",
    onClick: onClick
  }, _ref2);
};

var MobileMenuHeaderItem = function MobileMenuHeaderItem(_ref3) {
  var index = _ref3.index,
      onHeaderItemSelected = _ref3.onHeaderItemSelected,
      menuLink = _ref3.menuLink,
      isActive = _ref3.isActive;
  return React.createElement("li", null, React.createElement("div", {
    onClick: function onClick() {
      return onHeaderItemSelected(index);
    },
    tabIndex: "0",
    className: classnames('menu__mobile-heading-item', {
      'menu__mobile-heading-item--active': isActive
    })
  }, React.createElement("span", {
    className: "menu__mobile-heading-item-text"
  }, menuLink.heading.text)));
};

var MobileMenuHeader = function MobileMenuHeader(_ref4) {
  var onMobileMenuToggle = _ref4.onMobileMenuToggle,
      menuLinks = _ref4.menuLinks,
      LinkTemplate = _ref4.LinkTemplate,
      selectedIndex = _ref4.selectedIndex,
      onHeaderItemSelected = _ref4.onHeaderItemSelected;
  return React.createElement("div", {
    className: "menu__mobile-header"
  }, React.createElement(MobileMenuCloseButton, {
    onClick: onMobileMenuToggle
  }), React.createElement("ul", {
    className: "menu__mobile-heading-links"
  }, menuLinks.map(function (menuLink, index) {
    return React.createElement(MobileMenuHeaderItem, {
      key: menuLink.heading.text,
      index: index,
      LinkTemplate: LinkTemplate,
      menuLink: menuLink,
      isActive: selectedIndex === index,
      onHeaderItemSelected: onHeaderItemSelected
    });
  })));
};

var MobileSubmenu = function MobileSubmenu(_ref5) {
  var link = _ref5.link,
      LinkTemplate = _ref5.LinkTemplate,
      onItemSelected = _ref5.onItemSelected;
  return React.createElement("div", {
    className: "menu__mobile-submenu"
  }, React.createElement("span", {
    className: "menu__mobile-item-with-children"
  }, link.text), React.createElement("div", {
    className: "menu__mobile-submenu-container"
  }, link.subLinks.map(function (sublink, index) {
    return React.createElement(LinkTemplate, {
      onClick: function onClick() {
        return onItemSelected(index, sublink);
      },
      key: sublink.text,
      className: "menu__mobile-subitem link",
      url: sublink.url
    }, React.createElement("span", {
      className: "link__content"
    }, sublink.text));
  })));
};

var MobileMenuItem = function MobileMenuItem(_ref6) {
  var index = _ref6.index,
      link = _ref6.link,
      onItemSelected = _ref6.onItemSelected,
      LinkTemplate = _ref6.LinkTemplate;
  return React.createElement(React.Fragment, null, link.url && React.createElement(LinkTemplate, {
    onClick: onItemSelected,
    className: "menu__mobile-item link",
    url: link.url
  }, React.createElement("span", {
    className: "link__content"
  }, link.text)), !link.url && React.createElement(MobileSubmenu, {
    link: link,
    onItemSelected: onItemSelected,
    LinkTemplate: LinkTemplate
  }));
};

var _ref8 = React.createElement("span", {
  className: "link__content"
}, "Forside");

var MobileMenuItemSection = function MobileMenuItemSection(_ref7) {
  var menuLink = _ref7.menuLink,
      onItemSelected = _ref7.onItemSelected,
      LinkTemplate = _ref7.LinkTemplate;
  return React.createElement("section", {
    id: "".concat(menuLink.heading.text, "-panel"),
    className: "menu__mobile-panel"
  }, menuLink.heading.url && React.createElement(LinkTemplate, {
    onClick: onItemSelected,
    className: "menu__mobile-item link",
    url: menuLink.heading.url
  }, _ref8), menuLink.links.map(function (link, index) {
    return React.createElement(MobileMenuItem, {
      index: index,
      key: link.text,
      link: link,
      onItemSelected: onItemSelected,
      LinkTemplate: LinkTemplate
    });
  }));
};

var MobileMenu = function MobileMenu(_ref9) {
  var isOpen = _ref9.isOpen,
      LinkTemplate = _ref9.LinkTemplate,
      onMobileMenuToggle = _ref9.onMobileMenuToggle,
      menuLinks = _ref9.menuLinks,
      selectedHeaderIndex = _ref9.selectedHeaderIndex,
      onMenuItemSelected = _ref9.onMenuItemSelected,
      onMenuHeaderItemSelected = _ref9.onMenuHeaderItemSelected;
  return React.createElement("div", {
    className: classnames('menu__mobile', {
      'menu__mobile--open': isOpen
    })
  }, React.createElement(MobileMenuHeader, {
    onMobileMenuToggle: onMobileMenuToggle,
    menuLinks: menuLinks,
    LinkTemplate: LinkTemplate,
    selectedIndex: selectedHeaderIndex,
    onHeaderItemSelected: onMenuHeaderItemSelected
  }), React.createElement(MobileMenuItemSection, {
    menuLink: menuLinks[selectedHeaderIndex],
    onItemSelected: onMenuItemSelected,
    LinkTemplate: LinkTemplate
  }));
};

export default MobileMenu;